// Helper function to set the view to and zoom in on a marker

export default function flyToLocation(map, latitude, longitude, zoom) {

  if (!map) return;

  const duration = 0.5    // Animation speed

  // Calculate offset based on map width and move the view to focus on the marker. On desktop,
  // the map takes up the first half of the screen horizontally
  const isMobile = window.innerWidth <= 768;
  const mapWidth = !isMobile ? window.innerWidth * 0.5 : 0;

  if (mapWidth > 0) {
    const targetPoint = map.project([latitude, longitude], zoom);
    const offsetX = mapWidth / 2;
    const adjustedPoint = targetPoint.add([offsetX, 0]);
    const adjustedLatLng = map.unproject(adjustedPoint, zoom);

    map.flyTo(adjustedLatLng, zoom, { duration });
    
  } else {
    // No offset on mobile
    map.flyTo([latitude, longitude], zoom, { duration });
  }

}